'use client';

import type { ReactNode } from 'react';
import { UserButton, OrganizationSwitcher } from '@clerk/nextjs';
import { SwoopLogo } from '@ui/components/dashboard/SwoopLogo';
import { useOrgAutoSelect } from '@ui/components/dashboard/useOrgAutoSelect';

interface DashboardShellProps {
  children: ReactNode;
  hasOrg: boolean;
}

export const DashboardShell = ({ children, hasOrg }: DashboardShellProps) => {
  const orgActive = useOrgAutoSelect(hasOrg);

  return (
    <div className="flex h-screen flex-col bg-bg-0 font-sans text-text-1 text-sm antialiased">
      <header className="flex h-13 min-h-13 items-center border-b border-border-1 px-5">
        <div className="flex items-center gap-4">
          <div className="flex items-end gap-2.5 leading-none">
            <SwoopLogo className="h-6 -mb-[7.5px]" />
            <span className="text-[15px] font-bold text-text-0">Intelligent Search</span>
            <span className="font-mono text-[10px] text-text-3">v1</span>
          </div>
        </div>

        <div className="ml-auto flex items-center gap-4">
          {orgActive && (
            <OrganizationSwitcher
              hidePersonal
              afterCreateOrganizationUrl="/dashboard/assistants"
              afterLeaveOrganizationUrl="/dashboard/assistants"
              afterSelectOrganizationUrl="/dashboard/assistants"
              appearance={{
                elements: {
                  organizationSwitcherTrigger: {
                    color: 'white',
                    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' },
                    '&:focus': { boxShadow: 'none' },
                  },
                  organizationSwitcherTriggerIcon: { color: 'white' },
                  organizationPreviewMainIdentifier__organizationSwitcherTrigger: {
                    color: 'white',
                  },
                },
              }}
            />
          )}
          <UserButton />
        </div>
      </header>

      <main className="dashboard-scroll flex-1 overflow-y-auto p-6">
        {hasOrg && !orgActive ? null : children}
      </main>
    </div>
  );
};
